import React, { useState } from "react";
import { Grid2, CssBaseline, FormLabel } from "@mui/material";
// import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import AppInputField from "../../components/CommonReusableComponent/AppInputField/AppInputField";
import AppButton from "../../components/CommonReusableComponent/AppButton/AppButton";
import MUIErrorText from "../../components/MUIErrorText/MUIErrorText";
import { sendForgotPasswordEmail } from "../../helpers/api-functions-helper";
import { useSnackbar } from "../../contexts/Snackbar.context";
import forgotPasswordImg from "../../assets/images/Forgot-password-img.png"
// import { useMediaQuery } from '@mui/material';
import { FORM_VALIDATIONS, LOGIN_AND_FORGOT_PASSWORD, ERROR_MESSAGE, SNACKBAR_VARIANT } from "../../config/Messages.config";
import ZingAuditorLogo from "../../assets/images/ZingAuditorFullLogo.svg"
import { validateEmailField } from "../../common/CommonFunctions";
import "./Login-Forgot.Style.css"

const ForgotPassword = () => {
  document.title = 'Forgot Password | Zing Auditor'
  const { showSnackbar } = useSnackbar()
  const navigate = useNavigate();
  // let deviceSize = useMediaQuery('(max-width:700px)');
  const [isResetPasswordClicked, setIsResetPasswordClicked] = useState(false)

  // Function used to forgot password
  const handleForgotPasswordOfUser = (email) => {
    sendForgotPasswordEmail({email: email})
    .then((response) => {
      const { statusCode, success } = response.data;
      if (success && statusCode === 200) {
        showSnackbar(
          LOGIN_AND_FORGOT_PASSWORD.FORGOT_PASSWORD.LINK_SEND.SUCCESS,
          SNACKBAR_VARIANT.SUCCESS
        );
        navigate('/')
      } else {
        showSnackbar(
          LOGIN_AND_FORGOT_PASSWORD.FORGOT_PASSWORD.LINK_SEND.INVALID_MAIL,
          SNACKBAR_VARIANT.ERROR
        );
      }
    }).catch((error) => {
      console.log("Error: ", error)
      showSnackbar(
        LOGIN_AND_FORGOT_PASSWORD.FORGOT_PASSWORD.LINK_SEND.FAILED,
        SNACKBAR_VARIANT.ERROR
      );
    })
    .finally(() => {
      setIsResetPasswordClicked(false)
    })
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        // .matches(
        //   FORM_VALIDATIONS.EMAIL.REGEX,
        //   FORM_VALIDATIONS.EMAIL.MESSAGE
        // )
        // .required("Email is required")
        // .email("Must be a valid email"),
        .required(FORM_VALIDATIONS.EMAIL.REQUIRED)
        .test("email-validation", "Invalid email", function (value) {
          if (!value) {
            return this.createError({ message: "Email is required" });
          }
          const validationMessage = validateEmailField(value);
          return validationMessage === true
            ? true
            : this.createError({ message: validationMessage });
        }),
    }),
    onSubmit: (values) => {
      // console.log("Use Details: ", values);
      if (navigator.onLine) {
        const { email } = values;
        const revisedEmail = email.toLowerCase().trim();
        handleForgotPasswordOfUser(revisedEmail);
        setIsResetPasswordClicked(true);
      } else {
        showSnackbar(ERROR_MESSAGE.INTERNET_ERROR, SNACKBAR_VARIANT.ERROR);
      }
    },
  });

  return (
    <Grid2 container component="main" sx={{ height: "100vh" }}>
      <CssBaseline />
      <Grid2
        size={{xs: false, sm: false, md: 6}}
        sx={{
          backgroundImage: `url(${forgotPasswordImg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <Grid2
        size={{xs: 12, sm: 12, md: 6}}
        elevation={6}
        sx={{
          backgroundColor: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          className="forgot-password-container"
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className="d-flex justify-content-center mb-3">
            <img src={ZingAuditorLogo} alt="logo" style={{height: '35px'}} />
          </div>
          <Typography component="h1" variant="h5">
            Forgot password
          </Typography>
          <Typography variant="subtitle2" className="my-2">
            Please enter the email address associated with your account. If it
            matches our records, a password reset link will be sent to you.
          </Typography>
          <form
            noValidate
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
            }}
          >
            <Grid2 container className="my-0 py-0">
              <Grid2 size={{xs: 12}} className="mt-1">
                <FormLabel className="inter-regular-400 text-dark my-2">
                  Email
                </FormLabel>
                <AppInputField
                  ClassName="mb-3 inter-regular-400"
                  Size="small"
                  Type="email"
                  Id="email"
                  PlaceHolder="Enter Email"
                  Name="email"
                  Disabled={isResetPasswordClicked}
                  // OnChange={(e) => {
                  //   const { value, name } = e.target;
                  //   validation.handleChange({
                  //     ...e,
                  //     target: {
                  //       ...e.target,
                  //       name: name,
                  //       value: value.toLowerCase(),
                  //     },
                  //   });
                  // }}
                  OnChange={validation.handleChange}
                  OnBlur={validation.handleBlur}
                  Value={validation.values.email || ""}
                  Error={
                    validation.touched.email && validation.errors.email
                      ? true
                      : false
                  }
                  HelperText={
                    validation.touched.email && validation.errors.email ? (
                      <MUIErrorText ErrorMessage={validation.errors.email} />
                    ) : null
                  }
                />
              </Grid2>
            </Grid2>
            <AppButton
              Type="submit"
              variant="contained"
              ClassName="inter-regular-400"
              LoadingState={isResetPasswordClicked}
              IsDisabled={isResetPasswordClicked}
              SX={{
                mt: 2,
                mb: 2,
              }}
            >
              Submit
            </AppButton>
            <Typography
              variant="body2"
              className="inter-regular-400"
              color="text.secondary"
              align="center"
            >
              {"© "}
              {new Date().getFullYear()} All rights reserved | Powered by{" "}
              <Link
                to={"https://zingworks.in"}
                target="_blank"
                className="text-muted"
              >
                Zingworks
              </Link>
            </Typography>
            <Typography
              variant="body2"
              className="inter-regular-400 mt-2"
              color="text.secondary"
              align="center"
            >
              <Link
                to={"/"}
                style={{ textDecoration: "none" }}
                className="inter-regular-400 text-muted"
              >
                {"Back to Login"}
              </Link>
            </Typography>
          </form>
        </div>
      </Grid2>
    </Grid2>
  );
};

export default ForgotPassword;
